// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"219":"3187d953","395":"2f978f99"}[chunkId] + ".css";
};